const SUGGESTION_TYPES = ['add', 'delete', 'modify', 'minutes_addition'];

const suggestionMixin = {
	computed: {
		__DEFAULT_STATUSES() {
			const items = [
				{ id: 'yes', name: this.$t('accession') },
				{ id: 'approved', name: this.$t('approved') },
				{ id: 'addressed', name: this.$t('Addressed') },
				{ id: 'partially_approved', name: this.$t('partiallyApproved') },
				{ id: 'partially_addressed', name: this.$t('Partially addressed') },
				{ id: 'not_approved', name: this.$t('notApproved') },
				{ id: 'no', name: this.$t('notAccession') },
				{ id: 'sent_to_committee', name: this.$t('sentToCommittee') },
				{ id: 'withdrawn', name: this.$t('Withdrawn') },
				{ id: 'tie_vote', name: this.$t('Tie Vote') },
			];
			return items;
		},
		__DEFAULT_FILTER_STATUSES() {
			const items = [
				{ id: 'all', name: this.$t('allStatus') },
				{ id: 'none', name: this.$t('notProcessed') },
				...this.__DEFAULT_STATUSES,
			];
			return items;
		},
	},
	methods: {
		__suggestionStatus(status) {
			let statusLabel = status;
			switch (status) {
			case 'yes':
				statusLabel = this.$t('accession');
				break;
			case 'no':
				statusLabel = this.$t('notAccession');
				break;
			case 'partially_approved':
				statusLabel = this.$t('partiallyApproved');
				break;
			case 'not_approved':
				statusLabel = this.$t('notApproved');
				break;
			case 'approved':
				statusLabel = this.$t('approved');
				break;
			case 'accession':
				statusLabel = this.$t('accession');
				break;
			case 'not_accession':
				statusLabel = this.$t('notAccession');
				break;
			case 'sent_to_committee':
				statusLabel = this.$t('sentToCommittee');
				break;
			case 'withdrawn':
				statusLabel = this.$t('Withdrawn');
				break;
			case 'tie_vote':
				statusLabel = this.$t('Tie Vote');
				break;
			case 'addressed':
				statusLabel = this.$t('Addressed');
				break;
			case 'partially_addressed':
				statusLabel = this.$t('Partially addressed');
				break;
			case 'all':
				statusLabel = this.$t('allStatus');
				break;
			default:
				statusLabel = this.$t(status);
				break;
			}
			return statusLabel;
		},
		__checkIfLineNumberExist(suggestion) {
			const isNotNull = suggestion.material_ref_from && suggestion.material_ref_to;
			const isNotZero = suggestion.material_ref_from !== '0' && suggestion.material_ref_to !== '0';
			const isValid = isNotNull && isNotZero;
			return isValid;
		},
		__validateTypeValues(valueString) {
			// Initial
			const newValues = [];

			// Parse the string into an array
			const isValid = valueString !== undefined && valueString !== '' && typeof valueString === 'string';
			let values = [];
			try {
				values = isValid ? JSON.parse(valueString) : [];
			// eslint-disable-next-line no-empty
			} catch (e) {
			}

			for (let index = 0; index < values.length; index++) {
				const value = values[index];
				if (SUGGESTION_TYPES.includes(value)) {
					newValues.push(value);
				}
			}

			const newTextValue = JSON.stringify(newValues);
			return newTextValue;
		},
	},
	mounted() {
	},
};

export default suggestionMixin;
